/* tslint:disable */
/* eslint-disable */
/**
 * PopshopLive API
 * PopshopLive API service
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    RouteSegmentRawEventRequest,
    TrackEventRequest,
} from '../models';

export interface AnalyticsApiControllerRouteSegmentRawEventRequest {
    routeSegmentRawEventRequest: RouteSegmentRawEventRequest;
}

export interface AnalyticsApiControllerTrackEventsRequest {
    trackEventRequest: TrackEventRequest;
}

/**
 * 
 */
export class AnalyticsApi extends runtime.BaseAPI {

    /**
     * Public API with rate limit 10/s/ip
     */
    async analyticsApiControllerRouteSegmentRawEventRaw(requestParameters: AnalyticsApiControllerRouteSegmentRawEventRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.routeSegmentRawEventRequest === null || requestParameters.routeSegmentRawEventRequest === undefined) {
            throw new runtime.RequiredError('routeSegmentRawEventRequest','Required parameter requestParameters.routeSegmentRawEventRequest was null or undefined when calling analyticsApiControllerRouteSegmentRawEvent.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/routeSegmentRawEvent`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.routeSegmentRawEventRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Public API with rate limit 10/s/ip
     */
    async analyticsApiControllerRouteSegmentRawEvent(requestParameters: AnalyticsApiControllerRouteSegmentRawEventRequest): Promise<void> {
        await this.analyticsApiControllerRouteSegmentRawEventRaw(requestParameters);
    }

    /**
     * Public API with rate limit 10/s/ip
     */
    async analyticsApiControllerTrackEventsRaw(requestParameters: AnalyticsApiControllerTrackEventsRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.trackEventRequest === null || requestParameters.trackEventRequest === undefined) {
            throw new runtime.RequiredError('trackEventRequest','Required parameter requestParameters.trackEventRequest was null or undefined when calling analyticsApiControllerTrackEvents.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/t`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.trackEventRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Public API with rate limit 10/s/ip
     */
    async analyticsApiControllerTrackEvents(requestParameters: AnalyticsApiControllerTrackEventsRequest): Promise<void> {
        await this.analyticsApiControllerTrackEventsRaw(requestParameters);
    }

}
